import { createStyles } from "@material-ui/core";
import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import image1 from "v2/components/images/1.png";
import image2 from "v2/components/images/2.jpg";
import image3 from "v2/components/images/3.jpg";
import image4 from "v2/components/images/4.jpg";
import image5 from "v2/components/images/5.jpg";
const useStyles = createStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
  },
}));
export function CarouselView() {
  const styles = useStyles();
  return (
    <Carousel className={styles.root} autoPlay showThumbs={false} infiniteLoop>
      <div className={styles.root}>
        <img
          src={image1}
          alt="Berline"
          style={{
            backgroundImage: `url(${image1}) no-repeat cover`,
          }}
        />
        <p className="legend">BERLINE</p>
      </div>
      <div className={styles.root}>
        <img src={image2} alt="4x4" />
        <p className="legend">4x4</p>
      </div>
      <div className={styles.root}>
        <img src={image3} alt="SUV" />
        <p className="legend">SUV</p>
      </div>
      <div className={styles.root}>
        <img src={image4} alt="14_PLACES" />
        <p className="legend">14 PLACES</p>
      </div>
      <div className={styles.root}>
        <img src={image5} alt="UTILITAIRES" />
        <p className="legend">UTILITAIRES</p>
      </div>
    </Carousel>
  );
}
